import {
  GET_OWNER,
  GET_OWNER_SUCCESS,
  GET_OWNER_FAIL,
} from '../constants/types';

const initState = {
  loading: false,
  data: '',
  error: '',
};

const owner = (state = initState, action) => {
  switch (action.type) {
    case GET_OWNER:
      return {
        ...state,
        loading: true,
      };
    case GET_OWNER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
        error: '',
      };
    case GET_OWNER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: '',
      };
    default:
      return state;
  }
};

export default owner;
